import httpManager from "@/app/shared/utils/httpManager";
/**
 *
 * @param {number} strategyId Identificador de la estrategia.
 * @param {FormData} data Datos del IVR con el archivo de audio.
 */
export async function updateIvrOptions(strategyId, data) {
  const response = await httpManager.upload(`/strategies/${strategyId}/update-ivr/`, data);
  return response.data;
}
